import Bar from "react-top-loading-bar";
import { Color } from "@gcm/libs/tailwind";

function LoadingBar() {
  return <Bar color={Color("blue")} />;
}

export default LoadingBar;
